import BrowserWebLogo from '@/assets/browser-web-logo.svg?react';
import ClaudeLogo from '@/assets/claude-logo.svg?react';
import DocumentLogo from '@/assets/document-logo.svg?react';
import GoogleGeminiIcon from '@/assets/google-gemini-logo.svg?react';
import Gpt4oIcon from '@/assets/gpt-4o-logo.svg?react';
import ImageGeneratorLogo from '@/assets/image-generator-logo.svg?react';
import LinkAndAskLogo from '@/assets/link-and-ask-logo.svg?react';
import SuperbotLogo from '@/assets/superbot-logo.svg?react';
import type {
  ConversationModel,
  UpcomingConversationModel,
} from '@/features/conversations';
import { appConfig } from '@/providers/config';

export const models: Record<
  ConversationModel | UpcomingConversationModel,
  {
    icon: SvgComponent;
    chatIcon?: SvgComponent;
    premium: boolean;
    hidden: boolean;
    standalone: boolean;
    upcoming?: boolean;
    fileUploadSupport?: boolean;
    isNew?: boolean;
    filesUploadSupport?: true;
    modelRedirectSupport?: boolean;
    modelId: number;
    isDeprecated?: boolean;
  }
> = {
  'gpt-3.5': {
    icon: Gpt4oIcon,
    premium: false,
    hidden: false,
    chatIcon: 'chatIcon' in appConfig ? appConfig.chatIcon : undefined,
    standalone: false,
    filesUploadSupport: true,
    modelRedirectSupport: true,
    modelId: 0,
  },
  'gpt-4o': {
    icon: Gpt4oIcon,
    premium: true,
    hidden: false,
    standalone: false,
    chatIcon: 'chatIcon' in appConfig ? appConfig.chatIcon : undefined,
    filesUploadSupport: true,
    modelRedirectSupport: true,
    modelId: 11,
  },
  'gpt-5': {
    icon: Gpt4oIcon,
    premium: true,
    hidden: false,
    standalone: false,
    chatIcon: 'chatIcon' in appConfig ? appConfig.chatIcon : undefined,
    filesUploadSupport: true,
    modelRedirectSupport: true,
    modelId: 2,
  },
  gemini: {
    icon: GoogleGeminiIcon,
    premium: true,
    hidden: false,
    standalone: false,
    filesUploadSupport: true,
    modelId: 10,
  },
  claude: {
    icon: ClaudeLogo,
    premium: true,
    hidden: false,
    standalone: false,
    modelId: 15,
  },
  superbot: {
    icon: SuperbotLogo,
    premium: true,
    hidden: true,
    standalone: false,
    filesUploadSupport: true,
    modelId: 16,
  },
  chatbotapp: {
    icon: appConfig.logo,
    premium: true,
    hidden: true,
    standalone: false,
    modelId: 9,
  },
  'image-generator': {
    icon: ImageGeneratorLogo,
    premium: true,
    hidden: false,
    standalone: true,
    modelId: 4,
  },
  document: {
    icon: DocumentLogo,
    premium: true,
    hidden: false,
    standalone: true,
    fileUploadSupport: true,
    modelId: 7,
  },
  webSearch: {
    icon: BrowserWebLogo,
    premium: true,
    hidden: false,
    standalone: true,
    upcoming: !appConfig.featureFlags.webBrowsing,
    isNew: appConfig.featureFlags.webBrowsing,
    modelId: 14,
  },
  'link-and-ask': {
    icon: LinkAndAskLogo,
    premium: true,
    hidden: false,
    standalone: true,
    upcoming: true,
    modelId: 0,
  },
  nova: {
    icon: appConfig.logo,
    premium: true,
    hidden: true,
    standalone: false,
    modelId: 9,
  },
  aiapp: {
    icon: appConfig.logo,
    premium: true,
    hidden: true,
    standalone: false,
    modelId: 9,
  },
};
